export function formatCardExpiry(expiry?: string | null) {
  if (!expiry || expiry.length < 4) return null;

  return `${expiry.slice(0, 2)}/${expiry.slice(2, 4)}`;
}
